import React from "react";
import ForRentSetsList from "./for-rent-sets-list/for-rent-sets-list";

const ForRentSetsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForRentSetsList/>
            </div>
        </>
    )
};

export default ForRentSetsContainer;